import { ReactNode } from 'react';

import { RunningExperiments } from 'state/experiments';

export enum ExperimentVariants {
  Control = 'control',
  Treatment = 'treatment',
}

export interface IExperimentProps {
  // The key of the experiment
  flag: RunningExperiments;
  // The component returned when the experiment is on "treatment"
  treatment?: ReactNode;
  // The component returned when the experiment is on "control"
  control?: ReactNode;
  // The fallback component when the experiment is not running, if undefined will render "control"
  fallback?: ReactNode;
}
